import React, { useEffect, useState } from "react";
import { Alert, Spinner } from "react-bootstrap";
import { authFetch } from "../utils/authFetch";
// Legacy bookmarks select an implementation using the authenticated company's variant.
export default function SimausSwitch({ production, fallback }) {
  const [state, setState] = useState({ loading: true });
  useEffect(() => { let active = true;
    authFetch("/firma").then(data => {
      if (!data?.items?.length) throw new Error("Firma nu a fost încărcată.");
      if (active) setState({ simaus: data.items[0].app_variant === "SIMAUS" });
    }).catch(error => { if (active) setState({ error: error.message }); });
    return () => { active = false; };
  }, []);
  if (state.loading) return <div role="status"><Spinner size="sm" /> Se încarcă firma…</div>;
  if (state.error) return <Alert variant="danger">{state.error}</Alert>;
  return state.simaus ? production : fallback;
}
